const KEY = 'referral_ref';

/** Считывает ?ref= из текущего URL и запоминает. Вызывать на входе в приложение. */
export function captureRefFromUrl() {
  try {
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) localStorage.setItem(KEY, ref);
  } catch (_e) { /* ignore */ }
}

/** Возвращает сохранённый ref или ''. */
export function getStoredRef() {
  try { return localStorage.getItem(KEY) || ''; } catch (_e) { return ''; }
}

/** Очищает сохранённый ref (по желанию — после успешной регистрации). */
export function clearStoredRef() {
  try { localStorage.removeItem(KEY); } catch (_e) { /* ignore */ }
}